import React from 'react';
import { Link } from 'react-router-dom';
import { LogoMark } from './BrandLockup';
import { footerGroups, SYNEURAL_URL } from '../../data/navigation';
export function SiteFooter() {
  return <footer className="border-t border-ink/[0.06] bg-white/50" data-id="element-99" data-mp="t09rw4t8bepd">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8" data-id="element-100" data-mp="sxx0z25htu06">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_2fr]" data-id="element-101" data-mp="xzmgatzr0tu2">
          <div data-id="element-102" data-mp="1loowdxeqiemg">
            <div className="flex items-center gap-2.5" data-id="element-103" data-mp="1lo5nf672b0kk">
              <LogoMark data-id="element-104" data-mp="1lmm75fleopis" />
              <p className="text-[17px] font-semibold tracking-tight" data-id="element-105" data-mp="1qo1sl8rhwy1p">
                Noetivra{' '}
                <a href={SYNEURAL_URL} target="_blank" rel="noopener noreferrer" className="font-normal text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-106" data-mp="1coa8cqadylf9">
                  by SyNeural
                </a>
              </p>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-ink-soft" data-id="element-107" data-mp="5bqjzqe3d3xt">
              Connected knowledge. Clear insight. Intuitive control.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-4" data-id="element-108" data-mp="1sxfe1vk91tjg">
            {footerGroups.map(group => <nav key={group.title} aria-label={group.title} data-id="element-109" data-mp="26xq9zd0f1ybh">
                <h2 className="text-xs font-semibold text-ink" data-id="element-110" data-mp="22u20gos84snl">{group.title}</h2>
                <ul className="mt-4 space-y-2.5" data-id="element-111" data-mp="2gucpdm9z3x64">
                  {group.links.map(link => <li key={link.label} data-id="element-112" data-mp="2bvjdtze8yg8l">
                      {link.href ? <a href={link.href} target="_blank" rel="noopener noreferrer" className="text-sm text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-113" data-mp="2btfb3ks33n9w">
                          {link.label}
                        </a> : <Link to={link.to ?? '/'} className="text-sm text-ink-muted transition-colors duration-150 hover:text-ink" data-id="element-114" data-mp="2ujoegxzlxl36">
                          {link.label}
                        </Link>}
                    </li>)}
                </ul>
              </nav>)}
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-ink/[0.06] pt-6 text-xs text-ink-muted sm:flex-row sm:items-center sm:justify-between" data-id="element-115" data-mp="2az31d2cvxsxa">
          <p data-id="element-116" data-mp="2fw2xoljxnhb7">© {new Date().getFullYear()} SyNeural. Noetivra is a SyNeural product.</p>
          <p data-id="element-117" data-mp="2kybq9gsw8hcs">Interactive demonstrations use sample data.</p>
        </div>
      </div>
    </footer>;
}